import { render, staticRenderFns } from "./data-views.vue?vue&type=template&id=829b9400&scoped=true"
import script from "./data-views.vue?vue&type=script&lang=js"
export * from "./data-views.vue?vue&type=script&lang=js"
import style0 from "./data-views.vue?vue&type=style&index=0&id=829b9400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829b9400",
  null
  
)

export default component.exports